<template>
    <div>
        <v-app>
            <v-toolbar flat color="white">


                <v-toolbar-title class="congatec-gray">Setting administration</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-text-field id="setting_search_bar"
                              v-model="search"
                              class="searchbar"
                              append-icon="search"
                              label="Search"
                              single-line
                              hide-details></v-text-field>

                <v-btn id="create_setting_button" class="text-none" color="success" @click="onCreateSetting()"
                       v-if="createSetting">Create
                    setting
                </v-btn>
                <v-btn id="create_system_setting_button" class="text-none" color="success"
                       @click="onCreateSystemSetting()" v-if="createSystemSetting">
                    Create system setting
                </v-btn>


                <ShowSettingModal v-model="showSettingModal" :editMode="editMode" :disabled="disabled"
                                  :setting="setting"/>
                <ShowSystemSettingModal v-model="showSystemSettingModal" :editMode="editMode" :disabled="disabled"
                                        :systemSetting="systemSetting"/>
            </v-toolbar>


            <v-divider></v-divider>


            <SettingList v-if="readSetting" :isSystemSetting="false" :deleteSetting="deleteSetting"
                         :updateSetting="updateSetting" :search="search"/>

            <v-toolbar v-if="readSetting" flat color="white">
            </v-toolbar>

            <SettingList v-if="readSystemSetting" :isSystemSetting="true" :deleteSetting="deleteSystemSetting"
                         :updateSetting="updateSystemSetting" :search="search"/>
        </v-app>
    </div>
</template>

<script>

    import SettingList from './settings/SettingList.vue'
    import ShowSettingModal from "./settings/modals/ShowSettingModal";
    import ShowSystemSettingModal from "./settings/modals/ShowSystemSettingModal";
    import {EventBus} from "../eventbus";

    export default {
        name: "Settings",

        components: {
            SettingList,
            ShowSettingModal,
            ShowSystemSettingModal
        },

        data: () => ({
            search: "",

            setting: {
                settingId: null,
                key: null,
                value: null
            },

            systemSetting: {
                systemSettingId: null,
                key: null,
                value: null
            },

            emptySetting: {
                settingId: null,
                key: null,
                value: null
            },

            emptySystemSetting: {
                systemSettingId: null,
                key: null,
                value: null
            },

            readSetting: false,
            createSetting: false,
            deleteSetting: false,
            updateSetting: false,

            readSystemSetting: false,
            createSystemSetting: false,
            deleteSystemSetting: false,
            updateSystemSetting: false,

            error: false,
            errorMessage: null,

            editMode: false,
            disabled: false,
            showSettingModal: false,
            showSystemSettingModal: false
        }),

        created() {
            this.initializeRights();
        },

        mounted() {
            if (this.systemSetting) {

            } else {
                EventBus.$on('refreshSettingList', () => {
                    this.initialize();
                });
                EventBus.$on('settingModalClosed', () => {
                    this.initialize();
                    this.setting = Object.assign({}, this.emptySetting);
                    this.showSettingModal = false;
                    this.disabled = false;
                    this.editMode = false;
                });
                EventBus.$on('systemSettingModalClosed', () => {
                    this.initialize();
                    this.systemSetting = Object.assign({}, this.emptySystemSetting);
                    this.showSystemSettingModal = false;
                    this.disabled = false;
                    this.editMode = false;
                })
            }
        },

        methods: {
            initializeRights() {
                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "SettingRead") {
                        this.readSetting = true;
                    }

                    if (right.right === "SettingCreate") {
                        this.createSetting = true;
                    }

                    if (right.right === "SettingDelete") {
                        this.deleteSetting = true;
                    }

                    if (right.right === "SettingUpdate") {
                        this.updateSetting = true;
                    }

                    if (right.right === "SystemSettingCreate") {
                        this.createSystemSetting = true;
                    }

                    if (right.right === "SystemSettingDelete") {
                        this.deleteSystemSetting = true;
                    }

                    if (right.right === "SystemSettingUpdate") {
                        this.updateSystemSetting = true;
                    }

                    if (right.right == "SystemSettingRead") {
                        this.readSystemSetting = true;
                    }
                });
            },

            onCreateSetting() {
                this.editMode = false;
                this.setting = this.emptySetting;
                this.disabled = false;
                this.showSettingModal = true;
            },

            onCreateSystemSetting() {
                this.editMode = false;
                this.systemSetting = this.emptySystemSetting;
                this.disabled = false;
                this.showSystemSettingModal = true;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Settings.vue